import type { HTMLAttributes } from 'react';
import { styled } from '@mui/material';
import type { UIDefinitionStyles } from 'utils/styles';

export const Wrapper = styled('div')(({ columns }: { columns: boolean }) => ({
  display: 'flex',
  gap: '4px',
  width: '100%',
  flexDirection: columns ? 'column' : 'row',
  alignItems: columns ? 'flex-start' : 'center',
  overflow: 'auto',
}));

export const ItemWrapper = styled(
  ({
    isClickable,
    maxWidth,
    uiDefinitionStyles,
    ...props
  }: HTMLAttributes<HTMLDivElement> & { isClickable?: boolean; maxWidth?: string; uiDefinitionStyles?: UIDefinitionStyles }) => <div {...props} />,
  {
    shouldForwardProp: (prop) => prop !== 'isClickable',
  }
)(({ theme, isClickable, maxWidth, uiDefinitionStyles }) => ({
  width: 'auto',
  padding: '8px 12px',
  background: theme?.palette.secondary.light,
  borderRadius: '6px',
  maxWidth,
  cursor: isClickable ? 'pointer' : 'default',
  '& > .MuiTypography-root': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  '&> svg': {
    width: '12px',
    height: '12px',
  },
  ...uiDefinitionStyles,
}));

export const ModalContentWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px',
}));
